import { emit } from 'onyx-common/emitter'

export default emit
